import script from "./agent-status-legend.vue?vue&type=script&setup=true&lang=ts"
export * from "./agent-status-legend.vue?vue&type=script&setup=true&lang=ts"

import "./agent-status-legend.vue?vue&type=style&index=0&id=3db924b6&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db924b6"]])

export default __exports__